<template>
  <mdb-container class="gp-has-header">

    <data-table v-show="!showEditor" ref="demoData" :add-handler="create"
                :click-handler="editDemo"
                :columns="columns"
                add-label="New Rule"
                data-source="/demoData/list"
                page-title="Demo Data Rules"
                show-add-button/>

    <div v-if="showEditor" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-card>
        <mdb-card-body>
          <div>
            <mdb-input disabled v-model="currentDemo.groupName" label="Group"/>
            <mdb-btn size="sm" rounded @click="showGroupSearch = true">Change Group</mdb-btn>
            <mdb-input disabled v-model="currentDemo.eventTitle" label="Event"/>
            <mdb-btn size="sm" :disabled="!currentDemo.groupId" rounded @click="openEventSearch">Change Event</mdb-btn>
            <mdb-card>
              <mdb-card-header class="text-white">
                Message Threads
              </mdb-card-header>
              <mdb-card-body>
                <mdb-card v-for="(comment,i) in currentDemo.comments" :key="i">
                  <mdb-card-body>
                    <mdb-input label="Number of Participants" type="number" :min="1" :max="10" v-model.number="comment.participants"/>
                    <mdb-input label="Initial Message" type="text" v-model="comment.text"/>
                    <mdb-input label="Initial Message Partipant#" type="number" :min="1" :max="comment.participants" v-model.number="comment.participant"/>
                    <mdb-card v-for="(reply,j) in comment.replies" :key="i">
                      <mdb-card-header class="text-white secondary-color">Reply {{ j + 1}}</mdb-card-header>
                      <mdb-card-body>
                        <mdb-input label="Participant #" type="number" :min="1" :max="comment.participants" v-model.number="reply.participant"/>
                        <mdb-input label="Reply" type="text" v-model="reply.text"/>
                      </mdb-card-body>
                    </mdb-card>
                    <mdb-btn size="sm" rounded @click="addReply(i)">Add Reply</mdb-btn>
                  </mdb-card-body>
                </mdb-card>

                <mdb-btn size="sm" rounded @click="addThread">Add Thread</mdb-btn>
              </mdb-card-body>
            </mdb-card>
          </div>
          <mdb-btn :disabled="!(currentDemo.groupId && currentDemo.eventId)"
                   @click="save(false)">
            <mdb-icon icon="save"/>
            Save
          </mdb-btn>
          <mdb-btn :disabled="!(currentDemo.groupId && currentDemo.eventId)"
                   @click="save(true)">
            <mdb-icon icon="bolt"/>
            Test
          </mdb-btn>
          <mdb-btn v-if="clonedEvent"
                   @click="viewCloned()">
            <mdb-icon icon="external-link"/>
            View Generated Event
          </mdb-btn>
        </mdb-card-body>
      </mdb-card>

    </div>

    <mdb-modal v-if="showGroupSearch" size="lg" @close="showGroupSearch = false">
      <mdb-modal-header class="secondary-color text-white">
        <h5>Select Group for Demo Data Generation</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input v-model="groupQuery" type="text" @keydown.native="groupKeydown"/>
        <div v-for="group in groups" :key="group.id">
          <mdb-btn @click="selectGroup(group)" size="sm">Select</mdb-btn>
          {{ group.name }}
        </div>
        <mdb-btn color="success" icon="search" @click="groupSearch">Search</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="cancelGroupSearch">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="showEventSearch" size="lg" @close="showEventSearch = false">
      <mdb-modal-header class="secondary-color text-white">
        <h5>Select Event to Clone for Demo Data Generation</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input v-model="eventQuery" type="text" @keydown.native="eventKeydown"/>
        <div v-for="event in events" :key="event.id">
          <mdb-btn @click="selectEvent(event)" size="sm">Select</mdb-btn>
          {{ event.title }} ({{ event.id }})
        </div>
        <mdb-btn color="success" icon="search" @click="eventSearch">Search</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="showEventSearch = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import dataTable from "../common/DataTable";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';

export default {
  name: "demo-data",
  display: "Demo Data",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    dataTable,
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {

  },
  data() {
    return {
      demos: [],
      showGroupSearch: false,
      showEventSearch: false,
      clonedEvent: null,
      groupQuery: "",
      groups: [],
      eventQuery: "",
      events: [],
      currentDemo: {
        id: null, title: "", code: "", url: ""
      },
      showEditor: false,
      showViewer: false,

      columns: [
        {label: "Group", field: "groupName"},
        {label: "Event", field: "eventTitle"}
      ]
    }
  },
  methods: {
    addThread() {
      let thread = {participant: 1, participants:2, text:"", replies: []}
      this.currentDemo.comments.push(thread);
    },
    addReply(i) {
      let reply = {participant: 1, text:""}
      this.currentDemo.comments[i].replies.push(reply)
    },
    cancelGroupSearch() {
      this.showGroupSearch = false
      if (!this.currentDemo.id) this.showEditor = false
    },
    groupKeydown(e) {
      if (e.keyCode == 13 && this.groupQuery) this.groupSearch()
    },
    eventKeydown(e) {
      if (e.keyCode == 13 && this.groupQuery) this.eventSearch()
    },
    selectGroup: function (g) {
      this.showGroupSearch = false
      if (this.currentDemo.groupId != g.id) {
        this.currentDemo.eventId = null
        this.currentDemo.eventTitle = ""
      }
      this.currentDemo.groupName = g.name
      this.currentDemo.groupId = g.id
      if (! this.currentDemo.eventId) this.openEventSearch()
    },
    groupSearch: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/demoData/groupSearch", { q: this.groupQuery}).then(
        (results) => {
          this.groups = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    selectEvent: function (e) {
      this.showEventSearch = false
      this.currentDemo.eventTitle = e.title
      this.currentDemo.eventId = e.id
    },
    openEventSearch: function () {
      this.eventSearch()
      this.showEventSearch = true
    },
    eventSearch: function () {
      this.$store.dispatch("setExecuting", true)
      let payload = {groupId: this.currentDemo.groupId}
      if (this.eventQuery) payload.q = this.eventQuery
      api.post("/demoData/eventSearch", payload).then(
        (results) => {
          this.events = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    create: function () {
      this.currentDemo = {
        groupId: null, groupName: "", eventId: null, eventTitle: "", comments: []
      }
      this.showGroupSearch = true
      this.showEditor = true

    },
    save: function (execute) {
      this.$store.dispatch("setExecuting", true)
      this.currentDemo.execute = execute
      this.clonedEvent = null
      api.post("/demoData/save", this.currentDemo).then(
        (results) => {
          if (!this.currentDemo.id) this.currentDemo.id = results.data.id
          this.$notify.success({message: "Demo saved successfully."})
          this.clonedEvent = results.data.demoEvent
        },
        (error) => {
          this.$notify.error({message: "Error saving demo."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editDemo: function (link) {
      this.currentDemo = link
      this.showEditor = true
    },
    showList: function () {
      this.showEditor = false
      this.$store.dispatch("setDataTableReload", true)
    },
    viewCloned: function() {
      if (!this.clonedEvent) return
        this.$router.push("/event/show/" + this.clonedEvent)
    }
  }

}
;
</script>
